export const telegramChatHistoryModalName = 'telegram-chat-history';
